<p-dialog
  [visible]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: '640px'}"
  [closeOnEscape]="false"
  [dismissableMask]="false"
  [closable]="false"
  [header]="dialogTitle"
  (onHide)="closeDialog()">
  @if (showPrivateOffersDisabledNotice) {
    <div class="p-message p-message-warn" role="status">
        Private Offers is OFF for this account. You can save this rule, but it will not affect Offer Sets,
        and private offers and unlock prompts will not display until Private Offers is enabled.
    </div>
  }
  <form [formGroup]="ruleForm" class="rule-form">
    <div class="form-grid form-grid-two">
      <div class="form-row">
        <label>Rule Privacy</label>
        <p-selectButton
          formControlName="isPrivate"
          [options]="privacyOptions"
          optionLabel="label"
          optionValue="value"
          (onChange)="onPrivacySelectionChange()">
        </p-selectButton>
      </div>
    </div>
    <div class="form-grid form-grid-two">
      <div class="form-row" [pTooltip]="publicOfferSetTooltip" [tooltipDisabled]="!isPublicOfferSetSelected()">
        <label>Rule Type</label>
        <p-selectButton formControlName="ruleType" [options]="filteredRuleTypeOptions" optionLabel="label" optionValue="value" (onChange)="onRuleTypeChange()"></p-selectButton>
      </div>
      <div class="form-row">
        <label>Status</label>
        <p-toggle-switch formControlName="status"></p-toggle-switch>
      </div>
    </div>
    <div class="form-grid form-grid-two">
      <div class="form-row">
        <label>Offer Set</label>
        <p-select
          formControlName="offerSetId"
          [options]="filteredEligibleOfferSets"
          optionLabel="displayTitle"
          optionValue="id"
          placeholder="Select offer set"
          (onChange)="onOfferSetChange($event.value)">
        </p-select>
      </div>
      <div class="form-row" [pTooltip]="publicOfferSetTooltip" [tooltipDisabled]="!isPublicRuleSelection()">
        <label>Discount Amount</label>
        <p-inputNumber
          formControlName="dollarAmountDiscount"
          mode="currency"
          currency="USD"
          locale="en-US"
          [minFractionDigits]="0"
          [maxFractionDigits]="0">
        </p-inputNumber>
      </div>
    </div>

    @if (getSelectedOfferSetOfferText(); as offerText) {
      <div class="offer-text">
        {{ offerText }}
      </div>
    }

    <div class="section-divider">Vehicle Criteria</div>

    <div class="form-grid">
      <div class="form-row">
        <label>Condition</label>
        <p-select formControlName="vehicleCondition" [options]="conditionOptions" optionLabel="label" optionValue="value"></p-select>
      </div>
      <div class="form-row">
        <label>Year</label>
        <input pInputText type="number" formControlName="year" />
      </div>
      <div class="form-row">
        <label>Make</label>
        <p-select
          formControlName="makeId"
          [options]="makes"
          optionLabel="displayName"
          optionValue="id"
          placeholder="Select make"
          [filter]="true"
          filterBy="displayName,id"
          [showClear]="true"
          (onChange)="onMakeSelectionChange($event.value)"
          [appendTo]="'body'">
        </p-select>
      </div>
      <div class="form-row">
        <label>Model</label>
        <p-select
          formControlName="modelId"
          [options]="filteredModels"
          optionLabel="name"
          optionValue="id"
          placeholder="Select model"
          [filter]="true"
          filterBy="name,id"
          [showClear]="true"
          (onChange)="onModelSelectionChange($event.value)"
          [appendTo]="'body'">
        </p-select>
      </div>
      <div class="form-row">
        <label>Trim</label>
        <input pInputText type="text" formControlName="trim" />
      </div>
      <div class="form-row">
        <label>Vehicle Limit</label>
        <input pInputText type="number" formControlName="vehicleLimit" />
      </div>
      <div class="form-row">
        <label>Max Price</label>
        <p-inputNumber
          formControlName="maxSalePrice"
          mode="currency"
          currency="USD"
          locale="en-US"
          [minFractionDigits]="0"
          [maxFractionDigits]="0">
        </p-inputNumber>
      </div>
    </div>
    <div class="dialog-actions">
      <p-button label="Cancel" severity="secondary" (click)="closeDialog()"></p-button>
      <p-button
        label="Save"
        severity="success"
        [disabled]="savingRule || isProcessingDisabled"
        [loading]="savingRule"
        (click)="saveRule()">
      </p-button>
    </div>
  </form>
</p-dialog>
